export default "__VITE_ASSET__D2vsTHFz__"